import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getVendorListById, updateVendorData, saveVendorData } from "../../redux/actions/VendorActions";
import { getAllStateList, getAllCityStateWiseList, getAllUsertypeUserList, getAllUsersRoleWiseList } from "../../redux/actions/MasterActions";
import { getAllCityList } from "../../redux/actions/MasterActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import Preloader from "../../Components/Preloader";

const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [stateId, setStateId] = useState(null);
  const [roleCode,setroleCode]=useState("JUNIOR_ENGINEER");
  const [fieldErrors, setFieldErrors] = useState(null);

  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    vendorReducer: {
      loadingVendor,
      errorsVendor,
      vendorLists,
      changedVendorStatus,
    },
    masterReducer: {
      masterStateLists,
      masterCityStateWiseLists,
      masterUsertypeUserLists,
      masterUsersRoleWiseLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getAllStateList(auth?.accessToken));
      // dispatch(getAllUsertypeUserList(auth?.accessToken, 13, ''));
    }
  }, [auth?.accessToken]);

  useEffect(() => {
    if (auth?.accessToken && stateId) {
      dispatch(getAllCityStateWiseList(auth?.accessToken, stateId));
    }
  }, [auth?.accessToken, stateId, dispatch]);

  useEffect(() => {
    if (auth?.accessToken && roleCode) {
      dispatch(getAllUsersRoleWiseList(auth?.accessToken, roleCode));
    }
  }, [auth?.accessToken, roleCode, dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(getVendorListById(auth?.accessToken, id));
    }
  }, [auth?.accessToken, id, dispatch]);


  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
      dispatch(updateVendorData(auth?.accessToken, formData, id));
    }
    else {
      dispatch(saveVendorData(auth?.accessToken, formData));
    }
  };

  useEffect(() => {
    if (id) {
      if (vendorLists && Object.keys(vendorLists).length > 0) {
        setFormData({
          "vendorName": vendorLists?.vendorName,
          "vendorMobile": vendorLists?.vendorMobile,
          "vendorAddress": vendorLists?.vendorAddress,
          "cityId": vendorLists?.city?.id,
          "jenId": vendorLists?.jen?.id ,
          "stateId": vendorLists?.state?.id,
          "status": vendorLists?.status,
          "vendorCode": vendorLists?.vendorCode,
        });
      }
    }

  }, [vendorLists])

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsVendor && Object.keys(errorsVendor).length > 0) {
      if (errorsVendor?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsVendor?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_VENDOR_STATUS' });
      }
      else if (errorsVendor?.status === 400) {
        // Handle other status
        if (errorsVendor?.data?.errors && Array.isArray(errorsVendor.data.errors)) {
          const transformedErrors = {};
          errorsVendor.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      }
      else {
        dispatch({ type: 'RESET_DELETE_VENDOR_STATUS' });
      }
      console.log('fieldErrors', fieldErrors);
    }
  }, [errorsVendor, dispatch]);

  useEffect(() => {
    if (changedVendorStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedVendorStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_VENDOR_STATUS' });
      navigate(-1);
    }
  }, [changedVendorStatus, dispatch, navigate]);

  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_VENDOR_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase();
    setFormData({ ...formData, [name]: processedValue });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler = (selectedData, name) => {
    const selectedId = selectedData[0]?.id;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedId
    }));
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler2 = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0].value,
    }));
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandlerId = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0]?.id,
    }));
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: fieldErrors.stateId ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: fieldErrors?.stateId ? 'red' : base.borderColor,
      }
    }),
  };
  useEffect(()=>{
    setFieldErrors({})

  },[navigate]);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Vendor"), path: "Vendor" },
          { label: id ? t("Update Vendor") : t("Add Vendor"), path: "/Add-Vendor", active: true },
        ]}
        title={id ? t("Update Vendor") : t("Add Vendor")}
      />
      <Row>
        <Col lg={3}></Col>
        <Col lg={6}>
          <Card>
            <Card.Body>
              {errorsVendor?.data?.message && (

                <div className="alert alert-danger">
                  {errorsVendor?.data?.message}
                </div>
              )}

              <Row>
                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("State")}</Form.Label>
                    <Select
                    className={fieldErrors?.stateId ? "border-danger" : ""}
                      options={masterStateLists}
                      values={masterStateLists?.filter(state => state.stateId === formData.stateId)}
                      name="stateId"
                      labelField={"stateName"}
                      valueField={"stateCode"}
                      searchBy={"stateName"}
                      onChange={(selectedData) => {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                            stateId: selectedData[0]?.stateId,
                        }));
                        dispatch(getAllStateList(auth?.accessToken, selectedData[0]?.stateCode));
                        setStateId(selectedData[0]?.stateCode);
                      }}
                     
                    />
    

                    {fieldErrors?.stateId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.stateId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("City")}</Form.Label>
                    <Select
                    className={fieldErrors?.stateId ? "border-danger" : ""}

                      options={masterCityStateWiseLists}
                      values={masterCityStateWiseLists?.filter(city => city.cityId === formData.cityId)}
                      name="cityId"
                      labelField={"cityName"}
                      valueField={"cityCode"}
                      searchBy={"cityName"}
                      onChange={(selectedData) => {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          cityId: selectedData[0]?.cityId,
                        }));
                   
                      }}
                  
                    />

                    {fieldErrors?.cityId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.cityId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Vendor Code")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.vendorCode}
                    name="vendorCode"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Vendor Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.vendorName}
                    name="vendorName"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Mobile Number")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.vendorMobile}
                    name="vendorMobile"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Address")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.vendorAddress}
                    name="vendorAddress"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("J.E.N.")}</Form.Label>
                    <Select
                    className={fieldErrors?.stateId ? "border-danger" : ""}
                      options={masterUsersRoleWiseLists}
                     values={masterUsersRoleWiseLists?.filter(data => data?.id === formData?.jenId)}
                      name="jenId"
                      labelField={"name"}
                      valueField={"id"}
                        onChange={(selectedData) => {setFormData(prevFormData => ({
                          ...prevFormData,
                          jenId: selectedData[0]?.id
                        }));}}                      
                        
                        // styles={customSelectStyles}
                    />
                    {fieldErrors?.jenId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.jenId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-center">
                {loading ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loading && (<Preloader />)}
      {loadingMaster && (<Preloader />)}
      {loadingVendor && (<Preloader />)}
    </>
  );
};

export default Dashboard;
